<template>
  <charts />
</template>

<script>
import Charts from "@/components/charts/charts";

export default {
  components: {
    Charts
  }
};
</script>

<style></style>
